import {
    type FinishEventResponseType,
    type FinishEventRequestType
} from "./type";
import {
    request
} from "../request";

const FinishEvent = async (params: FinishEventRequestType): Promise<FinishEventResponseType> => {
    return await request<FinishEventResponseType>("/events/finishEvent", {
        body: JSON.stringify(params),
        method: "POST"
    });
};

export default FinishEvent;
